import React from "react";

export function EdenVoiceInputButton({ snapshot = {}, onClick }) {
  const phase = String(snapshot.phase || "idle");
  const active = Boolean(snapshot.active);
  const label = active ? "STOP" : "TALK";

  return (
    <button
      className="cphere-voice-panel-action cphere-voice-panel-action-cool"
      type="button"
      onClick={onClick}
      aria-label={active ? "Stop Eden voice input" : "Start Eden voice input"}
      aria-pressed={active}
      data-voice-input-state={phase}
    >
      {label}
    </button>
  );
}

export default EdenVoiceInputButton;
